async function exportInventoryPDF(e) {
  e.preventDefault();

  const btn = document.getElementById("btn-export-inventory-pdf");

  const originalText = btn.innerHTML;
  btn.style.pointerEvents = "none";
  btn.style.opacity = "0.6";
  btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Gerando...';

  // Get filter values
  const customerInput =
    document.getElementById("query_customer") ||
    document.querySelector("input[name*='customer']");
  const regionalInput =
    document.getElementById("query_regional") ||
    document.querySelector("input[name*='regional']");
  const localityInput =
    document.getElementById("query_locality") ||
    document.querySelector("input[name*='locality']");
  const typeInventoryInput =
    document.getElementById("query_type_inventory") ||
    document.querySelector("select[name*='type_inventory']");

  const customerId = customerInput ? customerInput.value : "";

  // Validation
  if (!customerId) {
    alert(
      "Por favor, selecione (ou digite) um Cliente no filtro para gerar o relatório.",
    );
    // Restore button
    btn.innerHTML = originalText;
    btn.style.pointerEvents = "auto";
    btn.style.opacity = "1";
    return;
  }

  try {
    console.log("--> Iniciando Fetch na API...");
    const url = new URL(window.location.origin + "/inventories/export_data");
    const params = new URLSearchParams();

    params.append("customer_id", customerId);
    if (regionalInput && regionalInput.value) {
      params.append("regional", regionalInput.value);
    }
    if (localityInput && localityInput.value) {
      params.append("locality", localityInput.value);
    }
    if (typeInventoryInput && typeInventoryInput.value) {
      params.append("type_inventory", typeInventoryInput.value);
    }

    url.search = params.toString();

    const response = await fetch(url);
    const result = await response.json();

    const records = result.data;

    if (!records || records.length === 0) {
      alert(
        "Nenhum inventário encontrado para este cliente com os filtros aplicados.",
      );
      // Restore button
      btn.innerHTML = originalText;
      btn.style.pointerEvents = "auto";
      btn.style.opacity = "1";
      return;
    }

    const printWindow = window.open("", "", "height=600,width=900");
    const htmlContent = `
      <html>
        <head>
          <title>Inventário - ${result.customer_name}</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 12px; color: #333; padding: 20px; }
            h1 { color: #003A70; border-bottom: 2px solid #003A70; padding-bottom: 10px; margin-bottom: 5px;}
            .meta { margin-bottom: 20px; color: #666; font-size: 14px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th { background-color: #f2f2f2; text-align: left; padding: 8px; border: 1px solid #ddd; font-weight: bold; font-size: 11px; }
            td { padding: 8px; border: 1px solid #ddd; font-size: 11px; }
            tr:nth-child(even) { background-color: #f9f9f9; }
            .footer { margin-top: 30px; font-size: 10px; text-align: center; color: #999; }
          </style>
        </head>
        <body>
          <h1>Relatório de Ativo Imobilizado (Inventário)</h1>
          <div class="meta">
            <strong>Cliente:</strong> ${result.customer_name}<br>
            <strong>Data de Emissão:</strong> ${new Date().toLocaleDateString()}<br>
            <strong>Total de Itens:</strong> ${result.total_records}
          </div>
         <table>
            <thead>
              <tr>
                <th style="width: 5%">ID</th>
                <th style="width: 30%">Descrição / Equipamento</th> 
                <th style="width: 25%">Modelo</th>                 
                <th style="width: 30%">Localidade</th>             
                <th style="width: 10%">Status</th>
              </tr>
            </thead>
            <tbody>
              ${records
                .map(
                  (r) => `
                <tr>
                  <td>${r.id}</td>
                  <td>${r.description}</td>
                  <td>${r.model}</td>
                  <td>${r.locality}</td>
                  <td>${r.status}</td>
                </tr>
              `,
                )
                .join("")}
            </tbody>
          </table>
          <div class="footer">Gerado via Sistema Omini</div>
          <script>
            window.onload = function() { window.print(); }
          </script>
        </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  } catch (error) {
    console.error("Erro ao gerar o PDF:", error);
    alert("Erro ao gerar o PDF. Verifique o console.");
  } finally {
    btn.innerHTML = originalText;
    btn.style.pointerEvents = "auto";
    btn.style.opacity = "1";
  }
}

async function exportSingleInventoryPDF(e) {
  e.preventDefault();

  const btn = e.currentTarget;
  const inventoryId = btn.dataset.inventoryId;
  const originalIcon = btn.innerHTML;

  btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
  btn.style.pointerEvents = "none";

  try {
    const response = await fetch(
      `/inventories/${inventoryId}/export_single_data`,
    );
    const result = await response.json();

    if (!result || !result.inventory) {
      alert("Inventário não encontrado.");
      return;
    }

    const { inventory, customer_name, locality_name, equipments } = result;

    const printWindow = window.open("", "", "height=800,width=800");
    const htmlContent = `
      <html>
        <head>
          <title>Ficha de Inventário #${inventory.id}</title>
          <style>
            body { font-family: Arial, sans-serif; font-size: 14px; color: #333; padding: 25px; }
            h1, h2 { color: #003A70; border-bottom: 2px solid #003A70; padding-bottom: 10px; margin-top: 25px; }
            .meta { margin-bottom: 20px; background-color: #f9f9f9; padding: 15px; border: 1px solid #eee; border-radius: 5px; }
            .meta strong { display: inline-block; width: 120px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th { background-color: #f2f2f2; text-align: left; padding: 10px; border: 1px solid #ddd; font-weight: bold; }
            td { padding: 10px; border: 1px solid #ddd; }
            tr:nth-child(even) { background-color: #f9f9f9; }
            .footer { margin-top: 40px; font-size: 12px; text-align: center; color: #999; }
          </style>
        </head>
        <body>
          <h1>Ficha Técnica de Inventário</h1>
          <div class="meta">
            <strong>ID do Inventário:</strong> ${inventory.id}<br>
            <strong>Cliente:</strong> ${customer_name}<br>
            <strong>Localidade:</strong> ${locality_name}<br>
            <strong>Tipo:</strong> ${inventory.type_inventory}<br>
            <strong>Status:</strong> ${inventory.active ? "Ativo" : "Inativo"}<br>
            <strong>Data de Criação:</strong> ${new Date(inventory.created_at).toLocaleDateString()}
          </div>

          <h2>Equipamentos</h2>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Modelo</th>
                <th>Fabricante</th>
                <th>Quantidade</th>
              </tr>
            </thead>
            <tbody>
              ${
                equipments && equipments.length > 0
                  ? equipments
                      .map(
                        (eq) => `
                <tr>
                  <td>${eq.name || "-"}</td>
                  <td>${eq.model || "-"}</td>
                  <td>${eq.manufacturer || "-"}</td>
                  <td>${eq.quantity || "1"}</td>
                </tr>
              `,
                      )
                      .join("")
                  : `<tr><td colspan="4" style="text-align: center;">Nenhum equipamento encontrado.</td></tr>`
              }
            </tbody>
          </table>
          <div class="footer">Gerado via Sistema Omini</div>
          <script>
            window.onload = function() { window.print(); }
          </script>
        </body>
      </html>
    `;
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  } catch (error) {
    console.error("Erro ao gerar o PDF individual:", error);
    alert("Erro ao gerar o PDF. Verifique o console.");
  } finally {
    btn.innerHTML = originalIcon;
    btn.style.pointerEvents = "auto";
  }
}

// Inicializador
function initInventoryPDF() {
  const btn = document.getElementById("btn-export-inventory-pdf");

  if (btn) {
    btn.removeEventListener("click", exportInventoryPDF);
    btn.addEventListener("click", exportInventoryPDF);
  }

  const singlePdfButtons = document.querySelectorAll(
    ".btn-export-single-inventory-pdf",
  );
  singlePdfButtons.forEach((btn) => {
    btn.removeEventListener("click", exportSingleInventoryPDF);
    btn.addEventListener("click", exportSingleInventoryPDF);
  });
}

document.addEventListener("turbolinks:load", initInventoryPDF);
document.addEventListener("DOMContentLoaded", initInventoryPDF);

